import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Upsurge handled everything. They never pressured us, kept us informed for the full three years, and delivered a consent worth several times what we had been offered before.",
    name: "Cotswold landowner",
    role: "12-acre farm holding · Consent Granted",
  },
  {
    quote: "What set them apart was the honesty. They told us up front that our site would need a Green Belt argument — and then made it.",
    name: "Family estate trustee",
    role: "Buckinghamshire · SHLAA submission",
  },
  {
    quote: "We had an awkward brownfield with contamination and no obvious developer interest. Upsurge built the viability case and brought us a buyer.",
    name: "Industrial landowner",
    role: "West Midlands · Mixed-Use consent",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-[#11171A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-28">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-6">
            <div className="overline"><span className="h-line" />Landowner voices</div>
            <h2 className="font-display text-[#F4EFE6] text-5xl md:text-6xl mt-6 leading-[0.95]">
              Trust earned, <span className="italic-gold">one acre at a time.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="text-[#9BA39B] leading-relaxed">
              Anonymised quotes from landowners we have worked with. We will happily put you in touch with references on request.
            </p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure key={t.name} data-testid={`testimonial-${i}`} className="border border-[#F4EFE6]/10 bg-[#0B0F0E] p-8 flex flex-col">
              <Quote className="text-[#C9A24B]" size={28} />
              <blockquote className="font-display text-xl md:text-2xl text-[#F4EFE6] mt-5 leading-snug flex-1">&ldquo;{t.quote}&rdquo;</blockquote>
              <figcaption className="mt-7">
                <div className="text-sm font-semibold text-[#F4EFE6]">{t.name}</div>
                <div className="text-xs tracking-[0.18em] uppercase text-[#C9A24B] mt-1">{t.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
